<div class="link-up-main-container">
  <div class="content">
    <pdq-card variant="popover" color="white">
      <div class="credentials-card">
        <pdq-heading element="h4">Client credentials</pdq-heading>
        <pdq-input
          variant="default"
          [disabled]="true"
          label="Username"
          [withEndIcon]="true"
          [clipboard]="true"
          [value]="adjustedUsername"
          (click)="copyToClipboard(adjustedUsername)"></pdq-input>
        <pdq-input
          variant="default"
          [disabled]="true"
          type="password"
          label="Password"
          [withEndIcon]="true"
          [clipboard]="true"
          [value]="linkUp?.printNodePassword"
          (click)="copyToClipboard(linkUp?.printNodePassword)"></pdq-input>

        <div class="text">Use these credentials to log into the PDQ Link Up app</div>
      </div>
    </pdq-card>
    <div class="text">
      PDQ Link Up allows you to seamlessly utilise a computers printers, scanners and more. Devices can be shared with
      any other user of your organisation, so they can be accessed from any computer, anywhere.

      <br />
      <br />
      To add a workstation, download the PDQ Link Up app on your computer, launch it, then use the credentials above to
      log in.
    </div>
  </div>
</div>
